import MainCard from 'ui-component/cards/MainCard';
import { Button, Grid, TextField, Typography, Box, InputLabel, Select, MenuItem, ButtonGroup, FormLabel } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router';

// components
import EditarProjetoForm from 'components/Projetos/EditarProjeto';

const EditarProjeto = () => {
    return (
        <MainCard title="Editar projeto">
            <Grid container spacing={gridSpacing}>
                <Box sx={{ width: '80%', margin: '0 auto', marginTop: '3em' }}>
                    <EditarProjetoForm />
                </Box>
            </Grid>
        </MainCard>
    );
};

export default EditarProjeto;
